import React from 'react';
import ReactDOM from 'react-dom/client';
import AppEscort from './AppEscort';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import store from './redux';
import './services/api-interceptor';

import './common/generalStyle.scss';

export const renderEscort = () => {
  const view = document.getElementById('escort-view');
  if (view) {
    const root = ReactDOM.createRoot(view);
    root.render(
      <BrowserRouter>
        <Provider store={store}>
          <AppEscort />
        </Provider>
      </BrowserRouter>
    );
  }
}

